import logger from '../common/logger';

const GU_API_URL = process?.env?.GU_API_URL ?? 'https://gu-api.com';
const PATH = '/events-collector'

const ANALYTICS_API_URL = `${GU_API_URL}${PATH}`;

const module = 'GiddyupServerSideTracker';
const GiddyupServerSideTracker = {
  trackEvent: (eventProperties) => {
    let eventPayload = null;

    try {
      eventPayload = {
        ...eventProperties,
        gucountry: eventProperties?.enhancedConversionData?.home_address?.country ?? '',
        regionCode: eventProperties?.enhancedConversionData?.home_address?.region ?? '',
        city: eventProperties?.enhancedConversionData?.home_address?.city ?? '',
        postalCode: eventProperties?.enhancedConversionData?.home_address?.postal_code ?? '',
      };

      let xhr = new XMLHttpRequest();
      xhr.open('POST', ANALYTICS_API_URL, true);
      xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');
      // xhr.onload = function () {}
      const json = JSON.stringify(eventPayload);
      xhr.send(json);

      return json;
    } catch (e) {
      logger.error('Web event track failed', e, { module, eventPayload });
    }
  }
};
export default GiddyupServerSideTracker;
